module.exports = __webpack_public_path__ + "static/img/1.b4c2d500.png";